var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"2000","srcdoc":_vm.html_form,"id":"iframe","sandbox":"allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }